import { faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext, useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { F2Scanner } from '../../components/Layout/F2Scanner'
import Footer from '../../components/Layout/Footer'
import Header from '../../components/Layout/Header'
import { PRODUCT_MAP } from '../../constants/products'
import { SiteConfigContext } from '../../context/siteConfigContext'
import { setPageTitle } from '../../utils/utilities'

const Scanner = () => {
  setPageTitle('Scanner')
  const { productsService } = useContext(SiteConfigContext)
  const [product, setProduct] = useState()

  useEffect(() => {
    if (productsService) {
      setProduct(productsService[PRODUCT_MAP.THIS_PRODUCT])
    }
  }, [productsService])

  if (!product) {
    return (
      <h1 className="flex items-center">
        Loading...{' '}
        <FontAwesomeIcon
          icon={faSpinner}
          className="h-4 w-4 ml-2 animate-spin"
        />
      </h1>
    )
  }

  if (!product.scanner) {
    return <Navigate to="/" />
  }

  return (
    <main className="flex flex-col h-screen bg-neutral-100 dark:bg-neutral-900">
      <Header />
      <div className="flex flex-1 overflow-auto flex-col gap-4 w-full h-full">
        <F2Scanner product={product} />
      </div>
      <div className="py-2">
        <Footer />
      </div>
    </main>
  )
}

export default Scanner
